export const DEALER_LOGIN = "/api/dealer/login";
export const DEALER_DETAILS = "/api/dealer/dealer-details";
export const DEALER_FORGOT_PASSWORD = "/api/dealer/forgot-password";
export const DEALER_RESET_PASSWORD = "/api/dealer/reset-password";

// For Orders
export const GET_DEALER_CART = "/api/dealer/fetch-cart-entry";
export const DEALER_SAVE_TO_CART = "/api/dealer/save-to-cart";
export const DELETE_CART = "/api/dealer/delete-cart-rows";
export const DEALER_PUNCH_ORDER = "/api/dealer/post-order-request";
export const GET_DEALER_ORDER_REQUESTS_LIST = "/api/dealer/order-request-list";
export const GET_DEALER_ORDERS_LIST = "/api/dealer/order-list";
